import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}

export function EmptyState({ icon, title, description, action, className }: EmptyStateProps) {
  return (
    <div className={cn('empty-state', className)}>
      {icon && <div className="empty-state-icon">{icon}</div>}
      <p className="font-semibold text-surface-900">{title}</p>
      {description && <p className="mt-1 text-sm text-surface-600">{description}</p>}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}
